/*
 * UTC calendar math, for code that keeps zone-free civil dates as UTC midnights (the task
 * schedule calendar). Periods picked in the UI are local time: see localDate.
 */
const MS_DAY = 86_400_000;

export const MONTHS_SHORT = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
] as const;

export const WEEKDAYS_SHORT = ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'] as const;

export const utcOf = (
  year: number,
  month: number,
  day: number,
  hours = 0,
  minutes = 0,
  seconds = 0,
  ms = 0,
): Date => new Date(Date.UTC(year, month, day, hours, minutes, seconds, ms));

export const isValidDate = (value: unknown): value is Date =>
  value instanceof Date && !Number.isNaN(value.getTime());

const startOfDayUTC = (d: Date): Date => utcOf(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());

export const endOfMonthUTC = (d: Date): Date =>
  utcOf(d.getUTCFullYear(), d.getUTCMonth() + 1, 0, 23, 59, 59, 999);

export const addDaysUTC = (d: Date, n: number): Date => new Date(d.getTime() + n * MS_DAY);

export const isSameDayUTC = (a: Date, b: Date): boolean =>
  startOfDayUTC(a).getTime() === startOfDayUTC(b).getTime();
